export { addClsInstrumentationHandler, addFidInstrumentationHandler, addInpInstrumentationHandler, addLcpInstrumentationHandler, addPerformanceInstrumentationHandler, addTtfbInstrumentationHandler } from './metrics/instrument.js';
export { addPerformanceEntries, startTrackingInteractions, startTrackingLongAnimationFrames, startTrackingLongTasks, startTrackingWebVitals } from './metrics/browserMetrics.js';
export { addClickKeypressInstrumentationHandler } from './instrument/dom.js';
export { addHistoryInstrumentationHandler } from './instrument/history.js';
export { clearCachedImplementation, fetch, getNativeImplementation, setTimeout } from './getNativeImplementation.js';
export { SENTRY_XHR_DATA_KEY, addXhrInstrumentationHandler } from './instrument/xhr.js';
export { registerInpInteractionListener, startTrackingINP } from './metrics/inp.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./node_modules/@sentry-internal/browser-utils/build/esm/index.js